<div class="modal-header">
    <h5 class="modal-title">Import Time Entries</h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-0">
    <div *ngIf="insertionMessage != null" class="progress-message">
        <span *ngIf="isInserting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ insertionMessage }}
    </div>

    <div *ngIf="formatError" class="alert alert-danger">
        <p>
            The format of the imported data is incorrect. Please download the template and ensure the data matches the
            required format.
        </p>
        <button class="download-button" matTooltip="Click here to download CSV format"
            (click)="downloadTemplate()">Download Template</button>
    </div>

    <!-- Original Data Table -->
    <div class="table-responsive" *ngIf="displayTable && !formatError">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <input type="checkbox" (change)="toggleSelectAll($event.target.checked)"
                        [checked]="selectedEntries.length === importedData.length && importedData.length > 0">
                </th>
                <td mat-cell *matCellDef="let entry">
                    <input type="checkbox" (change)="onCheckboxChange(entry, $event.target.checked)"
                        [checked]="isSelected(entry)">
                </td>
            </ng-container>

            <!-- Employee ID Column -->
            <ng-container matColumnDef="employeeId">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Employee ID</th>
                <td mat-cell *matCellDef="let entry">{{ entry.Employee_ID }}</td>
            </ng-container>

            <!-- Time In Column -->
            <ng-container matColumnDef="timeIn">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Time In</th>
                <td mat-cell *matCellDef="let entry">{{ entry.Time_In }}</td>
            </ng-container>

            <!-- Time Out Column -->
            <ng-container matColumnDef="timeOut">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Time Out</th>
                <td mat-cell *matCellDef="let entry">{{ entry.Time_Out }}</td>
            </ng-container>

            <!-- Table Header and Data Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <!-- Pagination -->
        <mat-paginator [pageSizeOptions]="[5,10]" showFirstLastButtons></mat-paginator>
    </div>

    <!-- Results Table -->
    <div class="table-responsive" *ngIf="showResults">
        <div class="results-summary">
            <div class="summary-item success">
                <strong>Successful:</strong> {{ successCount }}
            </div>
            <div class="summary-item failed">
                <strong>Failed:</strong> {{ failureCount }}
            </div>
        </div>

        <table mat-table [dataSource]="resultsDataSource" class="mat-elevation-z8">
            <!-- Employee ID Column -->
            <ng-container matColumnDef="employeeId">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Employee ID</th>
                <td mat-cell *matCellDef="let result">{{ result.Employee_ID }}</td>
            </ng-container>

            <!-- Time In Column -->
            <ng-container matColumnDef="timeIn">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Time In</th>
                <td mat-cell *matCellDef="let result">{{ result.Time_In }}</td>
            </ng-container>

            <!-- Time Out Column -->
            <ng-container matColumnDef="timeOut">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Time Out</th>
                <td mat-cell *matCellDef="let result">{{ result.Time_Out }}</td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let result">
                    <span [class.badge-success]="result.Status === 'Success'"
                        [class.badge-danger]="result.Status === 'Failed'"
                        [class.badge-warning]="result.Status === 'Skipped'" class="badge">
                        {{ result.Status }}
                    </span>
                </td>
            </ng-container>

            <!-- Message Column -->
            <ng-container matColumnDef="message">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Message</th>
                <td mat-cell *matCellDef="let result">{{ result.Message }}</td>
            </ng-container>

            <!-- Table Header and Data Rows -->
            <tr mat-header-row *matHeaderRowDef="resultColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: resultColumns;"></tr>
        </table>

        <!-- Results Pagination -->
        <mat-paginator #resultsPaginator [pageSizeOptions]="[5,10]" showFirstLastButtons></mat-paginator>
    </div>
</div>

<div class="modal-footer large-modal" *ngIf="!isImported && !showResults">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
    <button *ngIf="!isLoading; else loadingTemplate" [disabled]="formatError || selectedEntries.length === 0"
        type="button" class="btn btn-primary" (click)="saveSelectedEntries()">
        Import {{ selectedEntries.length }} {{ selectedEntries.length === 1 ? 'Entry' : 'Entries' }}
    </button>
    <ng-template #loadingTemplate>
        <button type="button" class="btn btn-primary" disabled>
            Processing... <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
    </ng-template>
</div>

<div class="modal-footer large-modal" *ngIf="showResults">
    <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
    <button *ngIf="failureCount > 0" type="button" class="btn btn-warning" (click)="retryFailed()">
        Retry Failed ({{ failureCount }})
    </button>
</div>

<div class="modal-footer large-modal" *ngIf="isImported">
    <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
</div>